<template>
  <div class="invoice-box-area">
    <div class="invoice-box-area__title">發票資料</div>
    <div class="invoice-box-area__box">
      <div class="one-choose-area">
        <p class="input-title">發票對象</p>
        <ul class="radio-area">
          <li class="custom-radio">
            <input type="radio" v-model="category" id="personal" value="B2C" />
            <label for="personal">個人戶</label>
          </li>
          <li class="custom-radio">
            <input type="radio" v-model="category" id="company" value="B2B" />
            <label for="company">公司戶</label>
          </li>
        </ul>
      </div>

      <div class="one-choose-area">
        <p class="input-title">索取發票</p>
        <ul class="radio-area">
          <li class="custom-radio">
            <input
              type="radio"
              v-model="invoiceType"
              id="paper"
              value="paper"
            />
            <label for="paper">紙本發票</label>
          </li>
          <li class="custom-radio" v-if="isB2C">
            <input
              type="radio"
              v-model="invoiceType"
              id="member-carrier"
              value="memberCarrier"
            />
            <label for="member-carrier">電子發票</label>
          </li>

          <li class="custom-radio" v-if="isB2C">
            <input
              type="radio"
              v-model="invoiceType"
              id="carrier"
              value="carrier"
            />
            <label for="carrier">
              電子發票載具
              <span class="warn" v-if="invoiceType == 'carrier'">
                ※選擇載具，則無法開立B2B發票
              </span>
            </label>
          </li>
        </ul>
      </div>

      <div
        class="single-input-field e-mail-area"
        v-if="isMemberCarrier && isB2C"
      >
        <p class="input-title">E-MAIL</p>
        <ValidationProvider
          :rules="{
            required_if: isMemberCarrier,
            email: true
          }"
          v-slot="{ errors, failed }"
        >
          <div class="custom-input" :class="{ failed: failed }">
            <input
              type="text"
              class="custom-text uniformNum"
              :placeholder="'請輸入E-MAIL'"
              name="email"
              v-model="email"
              autocomplete="off"
            />
          </div>

          <span class="warn">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="single-input-field" v-if="isB2B">
        <p class="input-title">統一編號</p>
        <ValidationProvider
          :rules="{
            max: 8,
            companySerialNoChecker: true,
            required_if: isB2B
          }"
          v-slot="{ errors, failed }"
        >
          <div class="custom-input" :class="{ failed: failed }">
            <input
              type="text"
              class="custom-text uniformNum"
              :placeholder="'請輸入統一編號'"
              name="uniformNum"
              v-model="uniformNum"
              autocomplete="off"
            />
          </div>

          <span class="warn">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <b-tabs
        v-model="tabIndex"
        content-class="mt-3"
        justified
        class="custom-tab"
        v-if="invoiceType == 'carrier'"
      >
        <b-tab title="手機條碼載具">
          <div class="tab-inside">
            <div class="single-input-field">
              <p class="input-title">手機條碼載具</p>

              <ValidationProvider
                :rules="{
                  mobilePhoneBarcode: true,
                  required_if: isMobilePhoneBarcodeCarrier
                }"
                v-slot="{ errors, failed }"
              >
                <div class="custom-input" :class="{ failed: failed }">
                  <input
                    type="text"
                    class="custom-text mobile"
                    :placeholder="'請輸入手機條碼載具'"
                    name="mobilePhoneBarcode"
                    v-model="mobilePhoneBarcode"
                    autocomplete="off"
                  />
                </div>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <MPBarcodeExample />
          </div>
        </b-tab>
        <b-tab title="自然人憑證條碼載具">
          <div class="tab-inside">
            <div class="single-input-field">
              <p class="input-title">自然人憑證條碼載具</p>

              <ValidationProvider
                :rules="{
                  naturalPersonCertificateBarcode: true,
                  required_if: isNaturalPersonCertificateBarcode
                }"
                v-slot="{ errors, failed }"
              >
                <div class="custom-input" :class="{ failed: failed }">
                  <input
                    type="text"
                    class="custom-text mobile"
                    :placeholder="'請輸入自然人憑證條碼載具'"
                    name="naturalPersonCertificateBarcode"
                    v-model="naturalPersonCertificateBarcode"
                    autocomplete="off"
                  />
                </div>
                <span class="warn">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <NPCBarcodeExample />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { localize } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';
import { isMobile } from 'mobile-device-detect';
import NPCBarcodeExample from '@/components/Invoice/NPCBarcodeExample';
import MPBarcodeExample from '@/components/Invoice/MPBarcodeExample';

export default {
  components: {
    NPCBarcodeExample,
    MPBarcodeExample
  },
  props: {
    member: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      category: 'B2C',
      invoiceType: 'paper',
      uniformNum: '',
      email: '',
      tabIndex: 0,
      isMobile: isMobile,
      mobilePhoneBarcode: null,
      naturalPersonCertificateBarcode: null
    };
  },
  computed: {
    isB2B() {
      return this.category === 'B2B';
    },
    isB2C() {
      return this.category === 'B2C';
    },
    categoryId() {
      return this.category === 'B2B' ? 1 : 2;
    },
    isCarrier() {
      //是否使用載具
      // return (
      //   this.invoiceType === 'carrier' || this.invoiceType === 'memberCarrier'
      // );
      return this.invoiceType === 'carrier';
    },
    //email 會員載具
    isMemberCarrier() {
      return this.invoiceType === 'memberCarrier';
    },
    isMobilePhoneBarcodeCarrier() {
      return this.invoiceType === 'carrier' && this.tabIndex == 0;
    },
    isNaturalPersonCertificateBarcode() {
      return this.invoiceType === 'carrier' && this.tabIndex == 1;
    },
    carrierType() {
      // 載具類別 0:手機條碼載具 1:自然人憑證條碼載具 2:ezPay 電子發票載具
      let type = null;

      if (this.isB2B || this.invoiceType === 'paper') {
        type = null;
      } else if (this.isMemberCarrier) {
        type = 2;
      } else if (this.isMobilePhoneBarcodeCarrier) {
        type = 0;
      } else if (this.isNaturalPersonCertificateBarcode) {
        type = 1;
      }

      return type;
    },
    carrierNum() {
      let num = null;

      if (this.isMobilePhoneBarcodeCarrier) {
        num = this.mobilePhoneBarcode;
      } else if (this.isNaturalPersonCertificateBarcode) {
        num = this.naturalPersonCertificateBarcode;
      }

      return num;
    },
    postData() {
      let data = {};
      data.category = this.categoryId;
      data.carrier_type = this.carrierType;

      if (this.isB2B) {
        data.tax_id = this.uniformNum;
      }

      if (this.isCarrier) {
        data.carrier_num = this.carrierNum;
      }

      if (this.isMemberCarrier) {
        data.email = this.email;
      }

      return data;
    }
  },
  watch: {
    isB2B(val) {
      if (val === true) {
        this.invoiceType = 'paper';
      }
    },
    member() {
      this.email = this.member.email;
      this.uniformNum = this.member.tax_number;
    }
  },
  created() {
    if (this.isMobile) {
      alert('現在是手機開啟');
      this.$router.push({ name: '歷史購買紀錄' });
    }
    localize({
      zh_TW: {
        messages: zh_TW.messages,
        names: {
          uniformNum: '統一編號',
          naturalPersonCertificateBarcode: '自然人憑證條碼載具',
          mobilePhoneBarcode: '手機條碼載具'
        },
        fields: {}
      }
    });
  },
  methods: {}
};
</script>
